import { useCallback, useEffect, useMemo, useRef } from "react";
import usePaginatedApiData from "../../../hooks/usePaginatedApiData";
import { buildPaginationParams } from "../../../utils/pagination";

export default function useProjectsData({
  token,
  page,
  pageSize,
  searchTerm,
  projectTypeFilter,
  projectPhaseFilter,
  projectManagerFilter,
  onUnauthorized,
}) {
  const unauthorizedRef = useRef(onUnauthorized);

  useEffect(() => {
    unauthorizedRef.current = onUnauthorized;
  }, [onUnauthorized]);

  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        project_type: projectTypeFilter || undefined,
        project_phase: projectPhaseFilter || undefined,
        project_manager: projectManagerFilter || undefined,
      }),
    [
      page,
      pageSize,
      searchTerm,
      projectTypeFilter,
      projectPhaseFilter,
      projectManagerFilter,
    ],
  );

  const handleError = useCallback((err) => {
    if (err?.response?.status === 401) {
      unauthorizedRef.current?.();
    }
  }, []);

  const {
    data: projects,
    totalCount,
    loading,
    refetch,
    setData: setProjects,
  } = usePaginatedApiData({
    endpoint: "/projects/",
    params,
    enabled: Boolean(token),
    errorMessage: "Failed to load projects",
    onError: handleError,
  });

  return {
    projects,
    totalCount,
    loading,
    setProjects,
    refetch,
  };
}
